import { ApiElements } from 'services/checkout-service/api';
import { Logo } from 'services/checkout-service/models';

const BUSINESS_LOGO_TYPE = 'BUSINESS';

export const extractMerchantBusinessLogo = (logos?: ApiElements<Logo>): string | undefined => {
  return logos?.elements && logos?.elements[0]?.logoType === BUSINESS_LOGO_TYPE ? logos.elements[0].url : undefined;
};
